import {useState} from 'react'
 
import FarmerInvoiceForm from './FarmerInvoiceForm';
import FarmerInvoiceList from './FarmerInvoiceList';

const FarmerInvoice = () => {
  const [formIsShown, setFormIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");
return (
  <>
    {formIsShown ? (
        <FarmerInvoiceForm addForm={setFormIsShown} update={upData} sId={serviceId}/>
      ) : (
        <FarmerInvoiceList addForm={setFormIsShown} update={setUpData} sId={setServiceId}/>
      )}

  </>
  )
}

export default FarmerInvoice